import React, { useState } from "react";
import "./Payment.css";
import FooterPage from "components/Global/FooterPage/FooterPage";
import Header from "components/Header/Header";
import CountrySelector from "./CountrySelector";
import { RegionSelector } from "./RegionSelector";
import MediaQuery, { useMediaQuery } from "react-responsive";
import { Form, Input, Button, Modal, InputNumber, Checkbox } from "antd";
import { processCancellationPolicy, formatPolicyText, formatPolicyType } from "helpers/GlobalHelper";
import PhoneInput from "react-phone-input-2";


const intialFormValue = {
  phone: '',
  age: '',
  address: '',
  code: '',
  city: '',
  country: '',
  state: ''
}

const PaymentFormComponent = ({location, form, ...props}) => {

  console.log("location", location)
  console.log("props", props)
  if (!location.state) throw new Error("Missing Hotel Booking Details");

  const { getFieldDecorator, getFieldValue, setFieldsValue, } = form;
  const {recommendationData: hotelBookingDetails} = location.state;

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  
  /************** State **************/
  const [policyModalVisible, setpolicyModalVisible] = useState(false);
  const [sameAddress, setsameAddress] = useState(true);
  const [termsAndConditions, settermsAndConditions] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  /************** End of State **************/

  /************** Components **************/
  const PolicyInfoModal = ({rates}) => {
    if (!rates.cancellationPolicies.length == 0 && !rates.policies.length == 0) return null;

    let refundTooltip = '';
    if (rates?.cancellationPolicies?.length) {
      const res = processCancellationPolicy(rates.cancellationPolicies);
      refundTooltip = `<div>${res.shortText}</div>`;
      refundTooltip += res.table;
    }

    return (
      <Modal
        title="Policies"
        visible={policyModalVisible}
        onCancel={() => setpolicyModalVisible(false)}
        closable={false}
        footer={[
          <Button key="back" onClick={() => setpolicyModalVisible(false)}>
            Close
          </Button>,
        ]}
      >
        {refundTooltip.length > 0 && (
          <div style={{ marginBottom: '10px' }}>
            <strong>Refundable Policy:</strong>
            <span dangerouslySetInnerHTML={{ __html: refundTooltip }} />
          </div>
        )}

        {rates?.policies?.map(
          (policy, index) => (
            <div key={index}>
              <strong>{formatPolicyType(policy.type)}:</strong>
              <div style={{ whiteSpace: 'break-spaces' }}>{formatPolicyText(policy.text)}</div>
            </div>
          )
        )}

      </Modal>
    )
  }

  const BookingPicDetails = () => {
    return (
      <div>
        <div className="mainHeading">Personal Details</div>
        <div className="bookingDetails">
            <div className="inputContainer firstname">
              <Form.Item style={{ margin: 0 }}>
                {getFieldDecorator("firstName", {
                  rules: [
                    {
                      required: true,
                      message: "Please input your name",
                    },
                    {
                      type: "string",
                      message: "Please input a valid name",
                    },
                  ],
                  initialValue: `${JSON.parse(localStorage.getItem("userdata"))?.first_name ?? ''}`,
                })(
                  <Input
                    style={{ border: "none", width: "100%" }}
                    placeholder="First Name"
                  />
                )}
              </Form.Item>
            </div>
            <div className="inputContainer lastname">
              <Form.Item style={{ margin: 0 }}>
                {getFieldDecorator("lastName", {
                  rules: [
                    {
                      required: true,
                      message: "Please input your name",
                    },
                    {
                      type: "string",
                      message: "Please input a valid name",
                    },
                  ],
                  initialValue: `${JSON.parse(localStorage.getItem("userdata"))?.last_name ?? ''}`,
                })(
                  <Input
                    style={{ border: "none", width: "100%" }}
                    placeholder="Name"
                  />
                )}
              </Form.Item>
            </div>

            <div
              className="inputContainer"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Form.Item style={{ margin: 0, width: "100%" }}>
                {getFieldDecorator("phone", {
                  rules: [
                    {
                      required: true,
                      message: "Invalid Phone Number",
                    },
                  ],
                  initialValue: JSON.parse(localStorage.getItem("userdata"))?.contactNumber ?? intialFormValue.phone,
                })(
                  <PhoneInput
                    // onChange={(phoneData, country) => autoSetCountryName(phoneData, country)}
                    inputClass="profiletelephoneinput"
                    containerClass="profiletelephoneinput"
                    dropdownStyle={{ border: "none" }}
                    placeholder="Phone"
                  />
                )}
              </Form.Item>
            </div>

            <div className="inputContainer">
              <Form.Item style={{ margin: 0 }}>
                {getFieldDecorator("email", {
                  rules: [
                    {
                      required: true,
                      message: "Please enter your email",
                    },
                    {
                      type: "email",
                      message: "Please input a valid email",
                    },
                  ],
                  initialValue: `${localStorage.getItem("useremail")}`,
                })(
                  <Input
                    style={{ border: "none", width: "100%" }}
                    placeholder="Email"
                  />
                )}
              </Form.Item>
            </div>

            <div className="inputContainer">
              <Form.Item style={{ margin: 0 }}>
                {getFieldDecorator("age", {
                  rules: [
                    { type: "integer", required: true, message: "Invalid Age" },
                  ],
                  initialValue: intialFormValue.age
                })(
                  <InputNumber
                    style={{ border: "none", width: "100%" }}
                    placeholder="Age"
                  />
                )}
              </Form.Item>
            </div>
        </div>
      </div>
    )
  }

  const BookingPicAddressDetails = () => {
    return (
      <div className="bookingDetails" style={{ marginBottom: 0 }}>
        <div className="inputContainer">
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator("address", {
              rules: [
                {
                  required: true,
                  message: "Please input your address",
                },
              ],
              initialValue: intialFormValue.address
            })(
              <Input
                style={{ border: "none", width: "100%" }}
                placeholder="Address"
              />
            )}
          </Form.Item>
        </div>

        <div className="doubleInput">
          <div
            className="inputContainer"
            style={{ width: "auto", marginRight: "1rem" }}
          >
            <Form.Item style={{ margin: 0 }}>
              {getFieldDecorator("code", {
                rules: [
                  {
                    required: true,
                    message: "Invalid postal code",
                  },
                ],
                initialValue: intialFormValue.code
              })(
                <Input
                  style={{ border: "none", width: "100%" }}
                  placeholder="Postal Code"
                />
              )}
            </Form.Item>
          </div>

          <div className="inputContainer" style={{ width: "auto" }}>
            <Form.Item style={{ margin: 0 }}>
              {getFieldDecorator("city", {
                rules: [
                  {
                    type: "string",
                    required: true,
                    message: "Please enter your city",
                  },
                ],
                initialValue: intialFormValue.city
              })(
                <Input
                  style={{ border: "none", width: "100%" }}
                  placeholder="City"
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div className="inputContainer">
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator("country", {
              rules: [
                {
                  required: true,
                  message: "Please enter your country",
                },
              ],
              // initialValue: intialFormValue.country
            })(
              <CountrySelector
                style={{ border: "none", width: "100%" }}
                // disabled
                onChange={(value) => {
                  form.setFieldsValue({
                    country: value,
                    state: undefined,
                  });
                }}
              />
            )}
          </Form.Item>
        </div>

        <div className="inputContainer">
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator("state", {
              rules: [
                {
                  required: true,
                  message: "Please enter your state",
                },
              ],
            })(
              <RegionSelector
                style={{ border: "none", width: "100%" }}
                // disabled={!!!form.getFieldValue("country")}
                country={form.getFieldValue("country")}
              // disabled
              />
            )}
          </Form.Item>
        </div>
    </div>
    )
  }

  const BillingAddressDetails = () => {
    return (
      <div>
        <Checkbox
          checked={sameAddress}
          onChange={() => setsameAddress(!sameAddress)}
          style={{ marginTop: "2rem", marginBottom: "1rem" }}
        >
          Billing address is the same as shipping address
        </Checkbox>
        { !sameAddress && (
            <div className="bookingDetails">
            <div className="inputContainer">
              <Form.Item style={{ margin: 0 }}>
                {getFieldDecorator("billingaddress", {
                  rules: [
                    {
                      required: true,
                      message: "Please input your billing address",
                    },
                  ],
                })(
                  <Input
                    style={{ border: "none", width: "100%" }}
                    placeholder="Billing address"
                  />
                )}
              </Form.Item>
            </div>

            <div className="doubleInput">
              <div
                className="inputContainer"
                style={{ width: "auto", marginRight: "1rem" }}
              >
                <Form.Item style={{ margin: 0 }}>
                  {getFieldDecorator("billingcode", {
                    rules: [
                      {
                        required: true,
                        message: "Invalid postal code",
                      },
                    ],
                  })(
                    <Input
                      style={{ border: "none", width: "100%" }}
                      placeholder="Postal Code"
                    />
                  )}
                </Form.Item>
              </div>

              <div className="inputContainer" style={{ width: "auto" }}>
                <Form.Item style={{ margin: 0 }}>
                  {getFieldDecorator("billingcity", {
                    rules: [
                      {
                        type: "string",
                        required: true,
                        message: "Please enter the billing city",
                      },
                    ],
                  })(
                    <Input
                      style={{ border: "none", width: "100%" }}
                      placeholder="Billing City"
                    />
                  )}
                </Form.Item>
              </div>
            </div>

            <div className="inputContainer">
              <Form.Item style={{ margin: 0 }}>
                {getFieldDecorator("billingcountry", {
                  rules: [
                    {
                      required: true,
                      message: "Please enter the billing country",
                    },
                  ],
                })(
                  <CountrySelector
                    placeholder="Select the billing country"
                    style={{ border: "none", width: "100%" }}
                    onChange={(value) => {
                      form.setFieldsValue({
                        billingcountry: value,
                        billingstate: undefined,
                      });
                    }}
                  />
                )}
              </Form.Item>
            </div>

            <div className="inputContainer">
              <Form.Item style={{ margin: 0 }}>
                {getFieldDecorator("billingstate", {
                  rules: [
                    {
                      required: true,
                      message: "Please enter your billing state",
                    },
                  ],
                })(
                  <RegionSelector
                    placeholder="Select the billing state"
                    style={{ border: "none", width: "100%" }}
                    disabled={!!!form.getFieldValue("billingcountry")}
                    country={form.getFieldValue("billingcountry")}
                  />
                )}
              </Form.Item>
            </div>
          </div>
        )}
    </div>
    )
  }
  
  const TermsAndConditions = () => {
    return (
      <div>
      <Checkbox
        checked={termsAndConditions}
        onChange={() => settermsAndConditions(!termsAndConditions)}
        style={{ marginBottom: "4rem" }}
      >
        Agree to terms and conditions
      </Checkbox>
    </div>
    )
  }

  const SubmitButton = () => {
    return (
      <Button
      type="primary"
      htmlType="submit"
      style={{ marginRight: "1rem" }}
      disabled={isLoading|| !termsAndConditions}
      onClick={handleSubmit}
    >
      {isLoading ? "Loading..." : "Book"}
    </Button> 
    )
  }

  /************** End of Components **************/

  /************** Functions **************/
  const handleSubmit = () => {
    setisLoading(true);
    setTimeout(() => {
      setisLoading(false);
    }, 3000);
  }

  return (
    <div className="PersonalDetailsContainer">
      <PolicyInfoModal rates={hotelBookingDetails?.hotel?.rates[0]} />
      <Header isMobile={isMobile} isDarkFont={true} />


      <div className="PersonalDetails">
        <div className="bookingDetailsContainer">
          <BookingPicDetails />
          <BookingPicAddressDetails />
          <BillingAddressDetails />
          <TermsAndConditions />
          <SubmitButton />
        </div>
      </div>

      <FooterPage />
    </div>
  )
}

const PaymentForm = Form.create({ name: "PaymentForm" })(PaymentFormComponent);


const Payment = (props) => {
  return <PaymentForm {...props} />
}

export default Payment